import { render, staticRenderFns } from "./UnauthenticatedUserFollowProjectEmailConfirmation.vue?vue&type=template&id=78d70ba8"
import script from "./UnauthenticatedUserFollowProjectEmailConfirmation.vue?vue&type=script&lang=js"
export * from "./UnauthenticatedUserFollowProjectEmailConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports